module.exports = __webpack_public_path__ + "img/3.55feef4d.jpg";